<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="专业成长数据统计"
      :page="false"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.getStatData"
      @reset="onReset"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="时间范围">
          <range-picker ref="picker" @change="x=>{params.StartDate=x.Start;params.EndDate=x.End;}" />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.TeacherName" placeholder="请填写教师姓名" clearable />
        </el-form-item>
        <el-form-item label="科目">
          <el-select v-model="params.Subjects" multiple collapse-tags>
            <template v-for="item in subjectList">
              <el-option :key="item.SubjectId" :value="item.Subject" :label="item.Subject"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="职称">
          <el-select v-model="params.Titles" multiple collapse-tags clearable>
            <el-option value="未定级" label="未定级"></el-option>
            <el-option value="二级" label="二级"></el-option>
            <el-option value="一级" label="一级"></el-option>
            <el-option value="高级" label="高级"></el-option>
            <el-option value="正高级" label="正高级"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职务">
          <el-select v-model="params.JobNames" multiple collapse-tags>
            <template v-for="item in jobList">
              <el-option :key="item.JobId" :value="item.JobName" :label="item.JobName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="获奖等次">
          <el-select v-model="params.GdGrades" multiple collapse-tags clearable>
            <template v-for="(i,k) in grades">
              <el-option :key="k" :value="i.DataName" :label="i.DataName"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Class1" label="大类" />
        <el-table-column prop="Class2" label="细类" />
        <el-table-column prop="Count1" label="国家级" width="90" />
        <el-table-column prop="Count2" label="省级" width="90" />
        <el-table-column prop="Count3" label="市级" width="90" />
        <el-table-column prop="Count4" label="校级" width="90" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {},
  data() {
    return {
      api: require("@/api/gd/common").default,
      jobApi: require("@/api/ent/job").default,
      subjectApi: require("@/api/ed/subject").default,
      base_api: require("@/api/gd/basedata").default,
      params: {
        StartDate: null,
        EndDate: null,
        Subjects: [],
        JobNames: [],
        GdGrades: [],
        Titles: [],
        TeacherName: "",
        date: [],
      },
      subjectList: [],
      jobList: [],
      grades: [],
    };
  },
  mounted() {
    this.subjectApi.list({}).then((res) => {
      this.subjectList = res.Data || [];
    });
    this.jobApi.list({}).then((res) => {
      this.jobList = res.Data || [];
    });
    this.base_api.list({}).then((res) => {
      this.grades = res.Data.filter((x) => x.ClassName == "等次");
    });
  },
  methods: {
    onReset() {
      this.$refs.picker.clear();
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.params);
      this.api.exportStatData(params).then((res) => {
        loading.close();
      });
    },
  },
};
</script>